import React from "react";
import { Link } from "react-router-dom";
import "./Footer.css";
import { FaInstagram, FaLinkedin, FaEnvelope } from "react-icons/fa";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        {/* Left section - Logo + About */}
        <div className="footer-section about">
          <div className="footer-logo">
            <img src="/logo.jpg" alt="Echelon Logo" className="footer-logo-img" />
            <div className="footer-logo-text">
              <h3>Echelon</h3>
              <p>Enlightening Future Minds</p>
            </div>
          </div>
          <p className="footer-about-text">
            Empowering students to learn, grow, and make an impact through volunteering and certification.
          </p>
        </div>

        {/* Middle section - Links */}
        <div className="footer-section links">
          <h4>Quick Links</h4>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/VolunteerHours">Dashboard</Link></li>
            <li><Link to="/GetCertified">Get Certified</Link></li>
            <li><Link to="/ContactUs">Contact Us</Link></li>
          </ul>
        </div>

        {/* Right section - Socials */}
        <div className="footer-section socials">
          <h4>Connect With Us</h4>
          <div className="footer-social-icons">
            <a href="mailto:secureechelon@gmail.com" target="_blank" rel="noreferrer"><FaEnvelope /></a>
            <a href="https://www.instagram.com/echeloncharlotte?utm_source=ig_web_button_share_sheet&igsh=ZDNlZDc0MzIxNw==" target="_blank" rel="noreferrer"><FaInstagram /></a>
            <a href="https://www.linkedin.com/in/echelon-charlotte" target="_blank" rel="noreferrer"><FaLinkedin /></a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© {new Date().getFullYear()} Echelon Volunteers | All Rights Reserved</p>
        <p>
          Icons by <a href="https://www.flaticon.com/" target="_blank" rel="noreferrer">Flaticon</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
